export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "083119a4-3310-4460-b107-17511a00abac";
export const MODAL_CLOSE_SEC = 2.5;
